var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23828 5.75781H14.7583L13.6783 15.4778H4.31828L3.23828 5.75781Z",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48145 5.76078V4.32078C6.48145 3.65244 6.74694 3.01146 7.21954 2.53887C7.69213 2.06628 8.3331 1.80078 9.00145 1.80078C9.66979 1.80078 10.3108 2.06628 10.7834 2.53887C11.2559 3.01146 11.5214 3.65244 11.5214 4.32078V5.76078",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.aa2a5a11a828453002b56054458a9573.svg";
export { ForwardRef as ReactComponent };